/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All supported query parameters.
 */
export const QUERY = {
  // FILTER: {},
  PAGE: {
    AFTER: 'page[after]',
    BEFORE: 'page[before]',
    SIZE: 'page[size]',
  },
};
